
namespace PaperTrail.NewsletterControl {

    @Serenity.Decorators.registerClass()
    export class NewsletterGrid extends Serenity.EntityGrid<NewsletterRow, any> {
        protected getColumnsKey() {
            if (Q.Authorization.hasPermission(PermissionKeys.Organizer)) {
                return NewsletterContributorColumns.columnsKey;
            }
            else {
                return NewsletterContributorColumns.columnsKey;
            }
        }
        protected getDialogType() { return NewsletterDialog; }
        protected getIdProperty() { return NewsletterRow.idProperty; }
        protected getInsertPermission() { return NewsletterRow.insertPermission; }
        protected getLocalTextPrefix() { return NewsletterRow.localTextPrefix; }
        protected getService() { return NewsletterService.baseUrl; }

        isOrganizer: boolean;

        //protected rowSelection: Serenity.GridRowSelectionMixin;

        constructor(container: JQuery) {
            super(container);

        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.enableCellNavigation = true;
            return opt;
        }

        protected createSlickGrid() {
             
            this.isOrganizer = Q.Authorization.hasPermission(PermissionKeys.Organizer);

            var grid = super.createSlickGrid();
            grid.setSelectionModel(new Slick.RowSelectionModel());

            // *** Enable Full size grid resize ***
            Common.GridHelper.EnableFullSizeGrid();

            var test = new Serenity.AutoColumnWidthMixin({
                grid: this
            }); 

            return grid;
        }

        private autoSize;
        // *** Resizes the columns after changes are made to the grid (ex. Column Picker) *
        protected markupReady() {
            super.markupReady();

            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

        protected getColumns(): Slick.Column[] {
            var columns = super.getColumns();

            columns.forEach(col => col.cssClass += " col-allowBackground");
            //columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));

            //columns.unshift({
            //    field: 'View Details',
            //    name: '',
            //    format: ctx => '<a class="inline-action view-details" title="view details"></a>',
            //    width: 30,
            //    minWidth: 30,
            //    maxWidth: 30,
            //    sortable: false,
            //    resizable: false
            //});
            //columns.splice(1, 0, {
            //    field: 'Delete Row',
            //    name: '',
            //    format: ctx => '<a class="inline-action delete-row" title="delete">' +
            //        '<i class="fa fa-trash-o text-red"></i></a>',
            //    width: 30,
            //    minWidth: 30,
            //    maxWidth: 30,
            //    sortable: false,
            //    resizable: false
            //});
            if (this.isOrganizer) {
                columns.unshift({
                    field: 'Invite',
                    name: '',
                    format: ctx => '<a class="inline-action invite-contributor" title="Invite someone to the newsletter">' +
                        '<i class="fa fa-envelope-open-text"></i> Invite</a>',
                    width: 70,
                    minWidth: 70,
                    maxWidth: 70,
                    sortable: false,
                    resizable: false
                });
                columns.unshift({
                    field: 'Preview Issue',
                    name: '',
                    format: ctx => '<a class="inline-action preview-newsletter" title="Preview issue">' +
                        '<i class="fa fa-eye"></i></a>',
                    width: 30,
                    minWidth: 30,
                    maxWidth: 30,
                    sortable: false,
                    resizable: false
                });
                columns.unshift({
                    field: 'Publish Issue',
                    name: '',
                    format: ctx => '<a class="inline-action publish-newsletter" title="Publish issue">' +
                        '<i class="fa fa-newspaper"></i></a>',
                    width: 30,
                    minWidth: 30,
                    maxWidth: 30,
                    sortable: false,
                    resizable: false
                });
                columns.unshift({
                    field: 'Template Tester',
                    name: '',
                    format: ctx => '<a class="inline-action template-tester" title="template tester">' +
                        '<i class="fa fa-play"></i></a>',
                    width: 30,
                    minWidth: 30,
                    maxWidth: 30,
                    sortable: false,
                    resizable: false
                });
            }
            columns.unshift({
                field: 'Write Story',
                name: '',
                format: ctx => '<a class="inline-action write-story" title="write a story">' +
                    '<i class="fa fa-pen-fancy"></i> Write a Story</a>',
                width: 110,
                minWidth: 110,
                maxWidth: 110,
                sortable: false,
                resizable: false
            });

            columns.unshift({
                field: 'Wizard',
                name: '',

                format: ctx => '<a class="inline-action story-wizard" title="Wizard">' +
                    '<i class="fa fa-magic"></i> Wizard</a>',
                width: 130,
                minWidth: 130,
                maxWidth: 160,
                sortable: false,
                resizable: false
            });

            columns.unshift({
                field: 'View Stories',
                name: '',

                format: ctx => '<a class="inline-action view-stories" title="View your stories">' +
                    '<i class="fa fa-book"></i> View your stories!</a>',
                width: 130,
                minWidth: 130,
                maxWidth: 160,
                sortable: false,
                resizable: false
            });

            return columns;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number): void {

            // let base grid handle clicks for its edit links
            super.onClick(e, row, cell);

            let self = this;

            // if base grid already handled, we shouldn"t handle it again
            if (e.isDefaultPrevented()) {
                return;
            }

            // get reference to current item
            var item = this.itemAt(row) as NewsletterRow;

            // get reference to clicked element
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('view-details')) {
                    this.editItem(item.NewsletterId);
                }
                else if (target.hasClass('delete-row')) {
                    Q.confirm('Delete record?', () => {
                        NewsletterService.Delete({
                            EntityId: item.NewsletterId,
                        }, response => {
                            this.refresh();
                        });
                    }); 
                }
                else if (target.hasClass('preview-newsletter')) {
                    NewsletterService.PublishNewsletter({
                        NewsletterEntity: item,
                        NewsletterID: item.NewsletterId
                    }, response => {
                        if (response.NewsletterContent.length > 0) {
                            var wnd = window.open("about:blank", "", "_blank");
                            if (wnd == null) {
                                Q.alert("Something went wrong. Please check that your browser did not block this pop-up.");
                            }
                            else {
                                wnd.document.write(response.NewsletterContent);

                                //var readyStateCheckInterval = setInterval(function () {
                                //    if (wnd.document.readyState === "complete") {
                                //        clearInterval(readyStateCheckInterval);
                                //        wnd.autoSizeTitles();
                                //    }
                                //}, 50);
                            }
                        }
                        else {
                            Q.alert("Something went wrong. Contact Support.");
                        }
                    });
                }
                else if (target.hasClass('publish-newsletter')) {
                    NewsletterService.PublishNewsletter({
                        NewsletterEntity: item,
                        NewsletterID: item.NewsletterId
                    }, response => { 

                        //Q.postToUrl({
                        //    url: '~/Serenity.Extensions/Report/Download',
                        //    params: {
                        //        key: 'Newsletter.Default',
                        //        ext: 'pdf',
                        //        opt: $.toJSON({
                        //            ReportDataCacheGUID: response.CacheId
                        //        })
                        //    },
                        //    target: '_blank'
                        //});


                        Q.postToService({
                            service: NewsletterControl.NewsletterService.baseUrl + '/DownloadNewsletter', request: {
                                FileName: response.ZipFileName
                            }, target: '_self'
                        });

                        //if (response.NewsletterContent.length > 0) {
                        //    var wnd = window.open("about:blank", "", "_blank");
                        //    if (wnd == null) {
                        //        Q.alert("Something went wrong. Please check that your browser did not block this pop-up.");
                        //    }
                        //    else {
                        //        wnd.document.write(response.NewsletterContent);
                        //    }
                        //}
                        //else {
                        //    Q.alert("Something went wrong. Contact Support.");
                        //}
                    });
                }
                else if (target.hasClass('invite-contributor')) {
                    var idlg = new NewsletterControl.InviteContributorDialog({
                        SubscriptionId: item.SubscriptionId,
                        SubscriptionName: item.SubscriptionName,
                        NewsLetterId: item.NewsletterId,
                        NewsletterName: item.NewsletterName,
                        Inviter: Q.Authorization.userDefinition.DisplayName
                    });

                    this.initDialog(idlg);
                    idlg.dialogOpen(false);
                }
                else if (target.hasClass('write-story')) {

                    var sdlg = new NewsletterControl.StoryContributorDialog();
                    this.initDialog(sdlg);
                    sdlg.loadEntityAndOpenDialog(<NewsletterControl.StoryRow>{
                        NewslettersList: [item.NewsletterId]
                    });
                }
                else if (target.hasClass('story-wizard')) {
                    e.preventDefault();

                    var diagStoryWizard = new NewsletterControl.StoryWizardDialog(null);

                    this.initDialog(diagStoryWizard);
                    diagStoryWizard.set_dialogTitle("New Story Wizard");

                    diagStoryWizard.selectedNewsletterId = item.NewsletterId;
                    diagStoryWizard.selectedNewsletter = item;

                    diagStoryWizard.dialogOpen(true);
                }
                else if (target.hasClass('template-tester')) {
                    
                }
                else if (target.hasClass('view-stories')) {
                    this.slickGrid.setSelectedRows(row);
                }
            }
        }
    }
}